export default "__VITE_ASSET__D7p_m77I__"